import { useEffect, useState, type ReactNode } from 'react';
import { FACT_ORDER } from '../lib/factOrder';
import '../pages/Loading.scss';

const FACT_SWAP_MS = 2500;

/** Presentational loading screen shared by the ID-card flow (`Loading`) and the
 * quiz flow (`QuizLoading`): title + subtitle, the swapping fun-fact stack, and
 * a slot for the offscreen element being rasterized. The compose / navigation
 * logic lives in each page; only the visuals + fact-swap timing live here. */
export default function LoadingView({
  title,
  subtitle,
  facts,
  children,
}: {
  title: string;
  subtitle: string;
  facts: string[];
  children?: ReactNode;
}) {
  const factA = facts[FACT_ORDER[0]] ?? facts[0] ?? '';
  const factB = facts[FACT_ORDER[1]] ?? facts[1] ?? factA;
  const [showSecond, setShowSecond] = useState(false);

  useEffect(() => {
    const id = window.setTimeout(() => setShowSecond(true), FACT_SWAP_MS);
    return () => window.clearTimeout(id);
  }, []);

  return (
    <div className="loading">
      <div className="loading__copy">
        <p className="loading__title">{title}</p>
        <p className="loading__subtitle">{subtitle}</p>
      </div>

      <div className="loading__fact-stack" aria-live="polite">
        <span className="loading__fact-bulb" aria-hidden="true">
          <img src="/img/bulb.svg" alt="" />
        </span>
        <p className={`loading__fact${showSecond ? '' : ' is-active'}`}>{factA}</p>
        <p className={`loading__fact${showSecond ? ' is-active' : ''}`}>{factB}</p>
      </div>

      {children}
    </div>
  );
}
